<template>
  <div class="pageBody">
    <div class="ohead">
      <el-date-picker
        v-model="val"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="getData">查 询</el-button>
      <div class="buttongroup">
        <span>订单总金额:{{ sumPrice }}</span>
        <el-button type="success" @click="handleExportExcel"
          >导出清单</el-button
        >
        <br />
      </div>
    </div>

    <div
      style="color: red; font-size: 12px; text-align: right; margin-left: auto"
    >
      推荐一次导出七天数据，否则可能因数据量过大导出失败
    </div>
    <div class="BodyRow">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :height="tableautoheight"
      >
        <el-table-column prop="ordno" type="index" label="NO">
        </el-table-column>
        <el-table-column prop="ordno" label="交易号"></el-table-column>
        <el-table-column prop="realname" label="客户名称"> </el-table-column>
        <el-table-column prop="userid" label="客户ID"> </el-table-column>
        <el-table-column prop="huiru" label="汇率"> </el-table-column>
        <el-table-column
          prop="ordnoKin"
          label="订单总金额（RMB）"
          class-name="colorLie"
          label-class-name="colorLie"
        >
        </el-table-column
        ><el-table-column
          prop="ordnoKin"
          label="订单总金额（JPY）"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ changeJap(scope.row.ordnoKin, scope.row) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="ggnsong"
          label="订单的国内运费(CNY)"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ Mathceil(scope.row.ggnsong) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ggnsong"
          label="订单的国内运费（JPY）"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ changeJap(scope.row.ggnsong, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="syohin"
          label="订单商品金额(CNY)"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ Mathceil(scope.row.syohin) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="syohin"
          label="订单商品金额（JPY）"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ changeJap(scope.row.syohin, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="poption"
          label="订单OPTION(CNY)"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ Mathceil(scope.row.poption) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="poption"
          label="订单OPTION（JPY）"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ changeJap(scope.row.poption, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="priceTenshu"
          label="订单手续费(CNY)"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ Mathceil(scope.row.priceTenshu) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="priceTenshu"
          label="订单手续费(JPY)"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ changeJap(scope.row.priceTenshu, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ta"
          label="其它费用(CNY)"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ Mathceil(scope.row.ta) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ta"
          label="其它费用（JPY）"
          class-name="colorLie"
          label-class-name="colorLie"
        >
          <template slot-scope="scope">
            <div>
              {{ changeJap(scope.row.ta, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="kno" label="付款方式"> </el-table-column>
        <el-table-column prop="yrealname" label="业务员"> </el-table-column>
        <el-table-column prop="deductionKin" label="抵扣余额（JPY）">
        </el-table-column>
        <el-table-column prop="deductionPoint" label="抵扣积分">
        </el-table-column>
        <el-table-column prop="baojiaSum" label="报价时金额（CNY）">
        </el-table-column>
        <el-table-column prop="datetime" label="付款时间" min-width="100">
        </el-table-column>
        <el-table-column prop="syukinOrdno" label="问题产品赔款（JPY）">
        </el-table-column>
      </el-table>
    </div>
    <div class="allpag">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="DataFrom.page"
        :page-sizes="[50]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getCurrentMonthFirst, getCurrentDayBefo } from "@/utlis/date";
export default {
  data() {
    return {
      val: [getCurrentMonthFirst(), getCurrentDayBefo()],
      DataFrom: {
        beginDatetime: null,
        endDatetime: null,
        page: 1,
        pageSize: 50,
      },
      total: 0,
      tableData: [],
      tableautoheight: window.innerHeight > 900 ? window.innerHeight - 288 : "",
    };
  },
  created() {
    // this.getData();
  },
  computed: {
    sumPrice() {
      let sum = 0;
      for (var i in this.tableData) {
        sum += Number(this.tableData[i].ordnoKin);
      }
      return Math.floor(sum * 100) / 100;
    },
  },
  mounted() {
    window.onresize = () => {
      this.tableautoheight =
        window.innerHeight > 900 ? window.innerHeight - 288 : "";
    };
  },
  methods: {
    // 根据汇率转换日元
    changeJap(num, item) {
      if (!num) {
        return "";
      }
      if (isNaN(Number(num))) {
        return num;
      }
      return (num * item.huiru).toFixed(0);
    },
    Mathceil(v) {
      if (!v) {
        return "";
      }
      if (isNaN(v)) {
        return v;
      }
      return parseInt(Number(v) * 100) / 100;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.DataFrom.page_num = val;
      this.DataFrom.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.DataFrom.page = val;
      this.getData();
    },
    async handleExportExcel() {
      if (this.val) {
        this.DataFrom.beginDatetime = this.val[0];
        this.DataFrom.endDatetime = this.val[1];
      } else {
        this.DataFrom.beginDatetime = "";
        this.DataFrom.endDatetime = "";
      }

      let datas = JSON.parse(JSON.stringify(this.DataFrom));
      datas.pageSize = 9999999;
      datas.page = 1;
      console.log(datas);
      var exceldata = [];
      await this.$api.financialApi
        .oemPayOrderList(datas)
        .then((res) => {
          console.log(res.code);
          if (res.code != 1) {
            this.$message.error("异常");
            return false;
          }
          res.data.list.forEach((listItem) => {
            listItem.ordnoKinRi = this.changeJap(listItem.ordnoKin, listItem);
            listItem.ggnsongRi = this.changeJap(listItem.ggnsong, listItem);
            listItem.syohinRi = this.changeJap(listItem.syohin, listItem);
            listItem.poptionRi = this.changeJap(listItem.poption, listItem);
            listItem.price_tenshuRi = this.changeJap(
              listItem.priceTenshu,
              listItem
            );
            listItem.taRi = this.changeJap(listItem.ta, listItem);
          });
          exceldata = res.data.list;
        })
        .catch((err) => {});

      require.ensure([], () => {
        const { export_json_to_excel } = require("@/utlis/Export2Excel");

        const tHeader = [
          "交易号",
          "客户名称",
          "客户ID",
          "订单总金额（RMB）",
          "订单总金额（JPY）",
          "业务员",
          "付款方式",
          "订单的国内运费(CNY)",
          "订单的国内运费(JPY)",
          "订单商品金额(CNY)",
          "订单商品金额(JPY)",
          "订单OPTION(CNY)",
          "订单OPTION(JPY)",
          "订单手续费(CNY)",
          "订单手续费(JPY)",
          "其它费用(CNY)",
          "其它费用(JPY)",
          "汇率",
          "抵扣余额(JPY)",
          "抵扣积分",
          "报价时金额(CNY)",
          "付款时间",
          "问题产品赔款(JPY)",
        ];
        const filterVal = [
          "ordno",
          "realname",
          "userid",
          "ordnoKin", //订单总金额（RMB）
          "ordnoKinRi",
          "yrealname",
          "kno",
          "ggnsong", //订单的国内运费
          "ggnsongRi",
          "syohin",
          "syohinRi",
          "poption",
          "poptionRi",
          "priceTenshu",
          "price_tenshuRi",
          "ta",
          "taRi",
          "huiru",
          "deductionKin",
          "deductionPoint",
          "baojiaSum",
          "datetime",
          "syukinOrdno",
        ];
        const list = exceldata; //把data里的tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "已付款客户订单列表");
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getData() {
      if (this.val) {
        this.DataFrom.beginDatetime = this.val[0];
        this.DataFrom.endDatetime = this.val[1];
      } else {
        this.DataFrom.beginDatetime = "";
        this.DataFrom.endDatetime = "";
      }
      console.log(this.DataFrom);
      this.$api.financialApi
        .oemPayOrderList(this.DataFrom)
        .then((res) => {
          console.log(res.code);
          if (res.code == "0") {
            this.tableData = [];
            return false;
          }
          this.tableData = res.data.list;
          this.total = Number(res.data.total);
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.ohead {
  * {
    margin-right: 15px;
  }

  .el-input {
    width: 220px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
}

.buttongroup {
  margin: 0px 0 20px auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  span {
    margin-right: 150px;
    font-size: 20px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
<style>
.colorLie {
  background-color: rgb(239, 217, 78);
  min-height: 69px;
}
</style>
